import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RoundButton from '../RoundButton.js';
import styles from './RoundButtonElement.module.scss.js';

function RoundButtonElement(_ref) {
  var onClick = _ref.onClick,
    status = _ref.status,
    icon = _ref.icon,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    isSelected = _ref.isSelected,
    unknownStatus = _ref.unknownStatus,
    area = _ref.area,
    text = _ref.text,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemWrapper, className)
  }, /*#__PURE__*/React.createElement(RoundButton, {
    status: status,
    icon: icon,
    disabled: disabled || isLoading,
    isLoading: isLoading,
    isSelected: isSelected,
    error: unknownStatus,
    onClick: onClick,
    dataTestId: dataTestId
  }), /*#__PURE__*/React.createElement("p", {
    className: classNames('min-line-height', styles.locationName, disabled && styles.disabled)
  }, area), /*#__PURE__*/React.createElement("p", {
    className: classNames('min-line-height', unknownStatus && !disabled ? 'awareness' : '', disabled ? styles.disabled : 'secondary', styles.statusName)
  }, text));
}
RoundButtonElement.propTypes = {
  onClick: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  area: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSelected: PropTypes.bool,
  unknownStatus: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};
RoundButtonElement.defaultProps = {
  disabled: false,
  isLoading: false,
  isSelected: false,
  unknownStatus: false,
  className: '',
  dataTestId: null
};

export { RoundButtonElement as default };
